import styled, { keyframes } from "styled-components";

const float = keyframes`
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
`;

const glowPulse = keyframes`
  0%, 100% { box-shadow: 0 0 30px rgba(133, 76, 230, 0.15), 0 0 60px rgba(133, 76, 230, 0.05); }
  50% { box-shadow: 0 0 40px rgba(133, 76, 230, 0.25), 0 0 80px rgba(133, 76, 230, 0.1); }
`;

export const HeroContainer = styled.div`
  background: ${({ theme }) => theme.bg};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 30px 30px 80px;
  min-height: 100vh;
  z-index: 1;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -10%;
    left: 50%;
    transform: translateX(-50%);
    width: 900px;
    height: 600px;
    background: radial-gradient(ellipse at center, rgba(99, 102, 241, 0.1) 0%, rgba(124, 106, 247, 0.05) 40%, transparent 70%);
    pointer-events: none;
    z-index: 0;
  }

  @media (max-width: 960px) {
    padding: 20px 16px 60px;
  }
  @media (max-width: 640px) {
    padding: 10px 16px 40px;
  }
`;

export const HeroBg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const HeroInnerContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1100px;
  gap: 40px;

  @media (max-width: 960px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const HeroLeftContainer = styled.div`
  width: 100%;
  order: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  
  @media (max-width: 960px) {
    order: 2;
    margin-bottom: 30px;
    align-items: center;
  }
`;

export const HeroRightContainer = styled.div`
  width: 100%;
  display: flex;
  order: 2;
  justify-content: flex-end;
  
  @media (max-width: 960px) {
    order: 1;
    justify-content: center;
    margin-bottom: 40px;
  }

  @media (max-width: 640px) {
    margin-bottom: 20px;
  }
`;

export const Img = styled.img`
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 400px;
  max-height: 400px;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.primary};
  object-fit: cover;
  animation: ${float} 6s ease-in-out infinite, ${glowPulse} 4s ease-in-out infinite;
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 44px;
  color: ${({ theme }) => theme.text_primary};
  line-height: 1.2;
  font-family: 'Poppins', sans-serif;
  letter-spacing: -0.5px;

  @media (max-width: 960px) {
    text-align: center;
    font-size: 38px;
  }
  @media (max-width: 640px) {
    font-size: 30px;
    margin-bottom: 4px;
  }
`;

export const TextLoop = styled.div`
  font-weight: 600;
  font-size: 28px;
  display: flex;
  gap: 10px;
  color: ${({ theme }) => theme.text_primary};
  line-height: 56px;

  @media (max-width: 960px) {
    text-align: center;
    justify-content: center;
  }
  @media (max-width: 640px) {
    font-size: 20px;
    line-height: 40px;
    flex-wrap: wrap;
  }
`;

export const Span = styled.span`
  background: ${({ theme }) => theme.gradient_text};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const SubTitle = styled.div`
  font-size: 17px;
  line-height: 1.8;
  margin: 16px 0 32px;
  color: ${({ theme }) => theme.text_secondary};
  max-width: 520px;
  white-space: pre-line;

  @media (max-width: 960px) {
    text-align: center;
    max-width: 480px;
  }
  @media (max-width: 640px) {
    font-size: 15px;
    line-height: 1.7;
    max-width: 100%;
  }
`;

export const ResumeButton = styled.a`
    -webkit-appearance: none;
    appearance: none;
    text-decoration: none;
    width: 100%;
    max-width: 260px;
    text-align: center;
    padding: 14px 0;
    color: ${({ theme }) => theme.white};
    border-radius: 50px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.5px;
    transition: all 0.3s ease;
    background: ${({ theme }) => theme.gradient_primary};
    box-shadow: 0 4px 24px ${({ theme }) => theme.shadow_primary};
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255,255,255,0.15), transparent);
      transition: left 0.5s ease;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 32px ${({ theme }) => theme.primary_glow};
      &::before {
        left: 100%;
      }
    }

    &:active {
      transform: translateY(0);
    }

    @media (max-width: 640px) {
      padding: 12px 0;
      font-size: 15px;
      max-width: 220px;
    }
`;
